var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"App"},[_c('router-view'),_c('notifications',{attrs:{"group":"notificateDiv","classes":"noticateStyle","position":"top right","width":450,"animation-name":"v-fade-left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }